// Milestone celebrations: a confetti burst + an optional love-note toast.
// Imperative so it can be fired from any handler. The toast is rendered by
// <CelebrationToast/> (mounted once in the dashboard) which listens for the event.
import confetti from 'canvas-confetti'

const COLORS = ['#C4826A', '#9BAF9B', '#D4AF37', '#E8B09A', '#7A917A']

export function celebrate({ title, note } = {}) {
  try {
    confetti({ particleCount: 90, spread: 72, origin: { y: 0.72 }, colors: COLORS, scalar: 0.9, disableForReducedMotion: true })
    setTimeout(() => confetti({ particleCount: 50, spread: 110, origin: { y: 0.6 }, colors: COLORS, scalar: 0.8, disableForReducedMotion: true }), 220)
  } catch { /* confetti is best-effort */ }
  if (title || note) {
    window.dispatchEvent(new CustomEvent('okoiya:celebrate', { detail: { title, note } }))
  }
}

// Fire a milestone only once ever (per browser) for a given key.
// Pass a wedding-scoped key, e.g. `firstYes:${weddingId}`.
export function celebrateOnce(key, payload) {
  try {
    const storageKey = `okoiya_celebrated_${key}`
    if (localStorage.getItem(storageKey)) return false
    localStorage.setItem(storageKey, '1')
  } catch { /* if storage blocked, still celebrate */ }
  celebrate(payload)
  return true
}
